<template>
  <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">文华财经小课堂 - 用wh5软件挖掘价值股</div>
        <p class="index-module_textWrap_3ygOc">近期股市低迷，很多股民赔钱了。
        </p>
        <p class="index-module_textWrap_3ygOc">但是，当前正是建仓的好时机，因为当前行情有可能会成为未来几年内的低点，价值投资正当其时！
        </p>
        <p class="index-module_textWrap_3ygOc">建什么仓？wh5软件帮你挖掘价值股。</p>
        <p class="index-module_textWrap_3ygOc">
            本期将介绍wh5软件选股应用的五大秘籍，讲述如何使用财务分析工具软件，帮助你选出真正有投资价值的好股票。
        </p>
         <div class="info table2">
            <table cellpadding="7" cellspacing="0" style="width: 730px;background: #f7f9fc;text-indent:0">
                <tr class="center">
                    <th valign="top">题目</th>
                    <th valign="top">内容</th>
                    <th valign="top" width="9%">讲师</th>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">定价数据</td>
                    <td>用定价倍数进行选股<br>
                    【描述】定价倍数=价格/基本面定价，对定价倍数排序、对比，判断个股价值是否被“低估”或“高估”。<br>
                    【秘籍】买定价倍数小于1的股票</td>
                    <td rowspan="6"  style="padding:0 5px;text-align:center;text-indent:0">关怀远</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">财务表现排名</td>
                    <td>用财务指标排名选股<br>
                    【描述】利用软件提供的TTM标尺化深加工后的财务数据列表，对重要财务指标进行排序对比分析。<br>
                    【秘籍】买ROE高、每股收益高，且每股现金流大的股票</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">股息率投资方法</td>
                    <td>用股息率选股<br>
                    【描述】用软件提供的财年分红数据、资产增值数据，进行分析。<br>
                    【秘籍】买股息率高、连续分红，且资产增值率稳定的股票。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">周期与趋势</td>
                    <td>行业周期性研究<br>
                    【描述】软件采取四分法对宏观经济数据和金融小周期波动进行划分，为大类资产配置和市场择时提供分析工具。<br>
                    【秘籍】选宏观经济利好正相关的行业。</td>
                </tr>
                <tr>
                    <td style="padding:0 5px;text-align:center;text-indent:0">基本面选股</td>
                    <td>利用基本面衍生数据选股<br>
                    【描述】软件提供各个企业市场表现、盈利能力、现金能力等多个角度的统计分析数据，可以用来筛选好企业。<br>
                    【秘籍】买各项数据好于行业中值的股票。</td>
                </tr>
            </table>
        </div>
        <div  class="index-module_textWrap_3ygOc">
                讲师介绍：
        </div>
        <!-- <div>【孙健】&nbsp;文华产品经理</div> -->
            <div  class="index-module_textWrap_3ygOc">
              【关怀远】  &nbsp;文华财经大客户业务部产品经理，15年从业经历，长期受邀全国各类授课活动，持续参与了文华wh系列及T系列软件的设计与完善，在为机构和专业客户提供解决方案的过程中积累了大量如何提高投资者交易技术的心得体会。
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.info,
.SignUp {
    color: #646464;
    line-height: 180%;
    padding: 0 0 3px 2em;
    font-size: 14px;
}
.info table{
    border: 1px solid #d1d7d7;
    border-collapse: collapse;
}

.info_2 {
    color: #646464;
    line-height: 180%;
    padding-bottom: 3px;
}

.info table {
    width: 688px;
}

.info th {
            padding: 5px 0;

    height: 24px;
    line-height: 24px;
    background: #a4bce2;
    color: #ffffff;
    border: 1px solid #d1d7d7;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
}

.info td {
    padding: 0;
     padding: 5px 8px;

    border: 1px solid #d1d7d7;
    vertical-align: middle;
    padding-left: 8px;
}

.info td.time {
    color: #002c6f;
}

.td_w,.td_b{
    line-height: 29px;
    padding: 0 0 0 22px;
    font-size: 14px;
    color: #646567;
}

.td_b{
    background: #eef0fd;
}
.table2 tr td:first-child{
    text-align: left !important;
    padding-left: 10px !important;
}
</style>